<header>
  <span>Historique</span>
  <span>{{labelOfSelectedItem}}</span>
  <div class='buttons'>
    <mat-spinner *ngIf='loading' diameter='24'></mat-spinner>
    <button class='settings-button'
            matTooltip='Retour à la configuration'
            mat-icon-button *ngIf='showSlider'
            color='primary'
            (click)='toggleForm()'>
      <mat-icon>settings</mat-icon>
    </button>
    <button mat-icon-button color='primary'>
      <mat-icon
        [matTooltip]="minimized ? 'Aggrandir' : 'Réduire'"
        (click)='minimized = !minimized'>{{minimized ? 'maximize' : 'minimize'}}</mat-icon>
    </button>
  </div>
</header>
<form *ngIf='!showSlider'
      (mousedown)='$event.stopPropagation()'
      [formGroup]='form'
      (submit)='formSubmit()'
      [style.visibility]="minimized ? 'hidden':'visible'"
      [style.height]="minimized ? '0' : '380px'"
      [style.padding]="minimized ? '0 10px' : '10px'">
  <section>
    <span class='title'>Périodicité</span>
    <mat-form-field>
      <mat-label>Récurrence</mat-label>
      <mat-select formControlName='recurrence'>
        <mat-option [value]='7'>Tous les jours</mat-option>
        <mat-option [value]='1'>Tous les lundis</mat-option>
        <mat-option [value]='2'>Tous les mardis</mat-option>
        <mat-option [value]='3'>Tous les mercredis</mat-option>
        <mat-option [value]='4'>Tous les jeudis</mat-option>
        <mat-option [value]='5'>Tous les vendredis</mat-option>
        <mat-option [value]='6'>Tous les samedis</mat-option>
        <mat-option [value]='0'>Tous les dimanches</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>de</mat-label>
      <input matInput type='text' maxlength='5' #hourStart placeholder='Ex. 06:00'
             formControlName='recurrenceHourStart' />
      <mat-hint align='end'>{{hourStart.value.length}} / 5</mat-hint>
      <mat-error *ngIf="form.controls.recurrenceHourStart.hasError('pattern')">Format invalide</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>à</mat-label>
      <input matInput type='text' maxlength='5' #hourEnd placeholder='Ex. 19:00' formControlName='recurrenceHourEnd' />
      <mat-hint align='end'>{{hourEnd.value.length}} / 5</mat-hint>
      <mat-error *ngIf="form.controls.recurrenceHourEnd.hasError('pattern')">Format invalide</mat-error>
    </mat-form-field>
    <mat-form-field class='colspan'>
      <mat-label>Pas de temps</mat-label>
      <mat-select formControlName='step'>
        <mat-option [value]='1'>Toutes les minutes</mat-option>
        <mat-option [value]='6'>Toutes les 6 minutes</mat-option>
        <mat-option [value]='15'>Tous les quarts d'heure</mat-option>
        <mat-option [value]='30'>Toutes les demi-heures</mat-option>
        <mat-option [value]='60'>Toutes les heures</mat-option>
      </mat-select>
    </mat-form-field>
  </section>
  <section>
    <span class='title'>Plage de consultation</span>

    <mat-form-field appearance='fill' class='colspan'>
      <mat-label>Choisir une plage de temps</mat-label>
      <mat-date-range-input [formGroup]='consultation' [rangePicker]='picker'>
        <input matStartDate formControlName='start' placeholder='Date de début'>
        <input matEndDate formControlName='end' placeholder='Date de fin'>
      </mat-date-range-input>
      <mat-hint>DD.MM.YYYY – DD.MM.YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]='picker'></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>

      <mat-error *ngIf="consultation.controls.start.hasError('matStartDateInvalid')">Date de début invalide</mat-error>
      <mat-error *ngIf="consultation.controls.end.hasError('matEndDateInvalid')">Date de fin invalide</mat-error>
    </mat-form-field>

  </section>

  <footer>
    <button color='primary' mat-raised-button type='submit' [disabled]='form.invalid || exportLoading'>Visualiser
    </button>

    <div>
      <button color='primary' mat-raised-button type='button' [disabled]='form.invalid || exportLoading'
              (click)='export()'>Exporter
      </button>
      <mat-spinner *ngIf='exportLoading' diameter='24'></mat-spinner>
    </div>
  </footer>
</form>

<app-historique-slider
  *ngIf='showSlider'
  [style.height]="minimized ? '0' : '80px'"
  [style.visibility]="minimized ? 'hidden':'visible'"
  [loading]='loading'
  [whereClauseFields]='whereClauseFields'
  [form]='history'
  (mousedown)='$event.stopPropagation()'
  (showForm)='showSlider = false'
  (select)='select($event)'
  (label)='label($event)'></app-historique-slider>
